<h2 mat-dialog-title>{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.ADD_HEADING' | translate }}</h2>

<mat-dialog-content class="container">
  @if (variables$ | async) {
    <glxy-form-field>
      <glxy-label>{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.CATEGORY' | translate }}</glxy-label>
      <input
        type="text"
        placeholder="{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.SELECT_A_CATEGORY' | translate }}"
        matInput
        required
        (input)="filterCategories()"
        [formControl]="categoryControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="categoryDisplayName.bind(this)"
        (optionSelected)="handleCategoryChange($event.option.value)"
      >
        @for (category of filteredCategories$ | async; track category) {
          <mat-option [value]="category">
            {{ category.textKey | translate }}
          </mat-option>
        }
      </mat-autocomplete>
    </glxy-form-field>
    @if (chosenCategory() !== null) {
      <glxy-form-field>
        <glxy-label>{{ chosenCategory().textKey | translate }}</glxy-label>
        <input
          type="text"
          placeholder="{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.SELECT_A_FIELD' | translate }}"
          matInput
          required
          (input)="filterParams()"
          [formControl]="paramControl"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="paramDisplayName.bind(this)"
          (optionSelected)="handleParamChange($event.option.value)"
        >
          @for (param of filteredParams(); track param) {
            <mat-option [value]="param">
              {{ param.displayName | translate }}
            </mat-option>
          }
        </mat-autocomplete>
      </glxy-form-field>
    }
    @if (chosenCategory() !== null && chosenParam() !== null && chosenCategory()?.options?.nestedDynamicSelector) {
      @if (chosenDynamicParam$ | async) {
        <glxy-form-field>
          <glxy-label>{{ chosenParam().displayName | translate }}</glxy-label>
          <input
            type="text"
            placeholder="{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.SELECT_ONE' | translate }}"
            matInput
            required
            (input)="filterParamDetails()"
            [formControl]="paramDetailsControl"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="paramDetailsDisplayName.bind(this)"
            (optionSelected)="handleParamDetailsChange($event.option.value)"
          >
            @for (paramDetail of filteredParamDetails$ | async; track paramDetail) {
              <mat-option [value]="paramDetail">
                {{ paramDetail.title | translate }}
              </mat-option>
            }
          </mat-autocomplete>
        </glxy-form-field>
      } @else {
        <div class="stencil-shimmer"></div>
      }
    }
  } @else {
    <glxy-empty-state size="small">
      <glxy-empty-state-title>
        {{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.NO_OPTIONS' | translate }}
      </glxy-empty-state-title>
    </glxy-empty-state>
  }
</mat-dialog-content>

<mat-dialog-actions class="actions">
  <div>
    <button mat-stroked-button (click)="close()">
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="add()" [disabled]="disabled()">
      {{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.ADD_BUTTON' | translate }}
    </button>
  </div>
</mat-dialog-actions>
